import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import { ThemeProvider } from "@flash-tecnologia/hros-web-ui-v2";
import Root from "./root.component";
import { trpc, trpcClient, queryClient } from "./api/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { MenuSetupCard } from "./components/external-components/MenuSetupCard/menu-setup-card";
import { FlagsProvider } from "@flash-tecnologia/feature-flags";
import { NuqsAdapter } from "nuqs/adapters/react";
import { useSession } from "./hooks";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
});

export const { bootstrap, mount, unmount } = lifecycles;

interface SetupCardShortcutProps {
  isCollapsed?: boolean;
}

function SetupCardShortcut({ isCollapsed }: SetupCardShortcutProps) {
  const { companyId, economicGroupId, userId } = useSession();

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <FlagsProvider
          appName="hros-web-setup"
          url={process.env.UNLEASH_PROXY_URL || ""}
          token={process.env.UNLEASH_PROXY_KEY || ""}
          refreshIntervalSeconds={1800}
          initialContext={{
            userId,
            properties: {
              economicGroupId,
              companyId,
              employeeId: userId,
            },
          }}
        >
          <NuqsAdapter>
            <ThemeProvider>
              <BrowserRouter>
                <MenuSetupCard isCollapsed={isCollapsed} />
              </BrowserRouter>
            </ThemeProvider>
          </NuqsAdapter>
        </FlagsProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}

export { SetupCardShortcut };
